@if (legalTextsState()?.done) {
  @if (legalText()) {
    <div class="container my-4 mb-3">
      <rs-web-card>
        <div class="primary-text" [innerHTML]="legalText()"></div>
      </rs-web-card>
    </div>
  } @else {
    <div class="legal-text-missing">
      <img class="legal-text-missing__image" src="/web/images/legal-text-missing.svg" alt="" />
      <div class="legal-text-missing__text">
        <h1 class="im:h1">
          @if (legalTextName(); as name) {
            {{ 'legal.text_missing_h' | translate: { name: (name | translate) } }}
          } @else {
            {{ 'legal.text_missing_generic_h' | translate }}
          }
        </h1>
        <p class="im:body">{{ 'legal.text_missing_l' | translate }}</p>
      </div>
      @if (!isLoggedIn()) {
        <button im-button class="primary legal-text-missing__button" routerLink="/login">
          {{ 'legal.back_to_login_a' | translate }}
        </button>
      }
    </div>
  }
} @else {
  <div class="loading-area d-flex justify-content-center">
    <rs-web-loader></rs-web-loader>
  </div>
}
